// @ts-check
import { createDoseProp } from '../utils/dose-prop'
import { replaceObjectRawKeys } from '../utils/object'

const prop = createDoseProp({
  route: 'inhalation',
  drugInfoProp: 'inhalationAgents',
  mapFn: replaceObjectRawKeys,
})

/**
 * @param {string} id
 * @param {{
 *   amount: number
 *   time: number
 * }} updates
 * @returns {any} The changes to apply to the case.
 */
export const actionUpdateInhalationDosage = (id, updates) =>
  prop.actionUpdateDosage(id, updates)

/**
 * @param {string} id
 * @returns {any} The changes to apply to the case.
 */
export const actionClearInhalationDosage = id => ({
  [`drugDosage.inhalation.doses.${id}`]: null,
})

/**
 * @type {(
 *   caseData: CaseData
 * ) => {
 *   [drugId: string]: {
 *     amount: number
 *     time: number
 *   }
 * }}
 */
export const selectInhalationDosage = prop.selectDosageRaw
